import React from "react";
import axios from '../../axios/axiosconf'
import { debeFiltrarPorProfesional } from '../../../utils/userAccessHelpers';
import { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../general/Loading";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ModalResumenRemision from "./ModalResumenRemision";
import { formatFecha } from "../../../resources/Helper";
import SignatureCanvas from 'react-signature-canvas';
import html2pdf from "html2pdf-fix-jspdf";

function ModalConsentimientos(props) {

    const queryParams = useLocation().search;
    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(true);
    const [client, setClient] = useState([]);

    const paciente_id = new URLSearchParams(queryParams).get('id');

    const [pacienteId, setPacienteId] = useState(new URLSearchParams(queryParams).get('id'));

    
    const [contenido, setContenido] = useState('');
    const [fechaHora, setFechaHora] = useState('');

    const [nombreProfesional, setNombreProfesional] = useState('');
    const [registroMedico, setRegistroMedico] = useState('');
    const [codigoHabilitacion, setCodigoHabilitacion] = useState('');
    const [firmaimg, setFirmaimg] = useState('');
    const [textoPieFirma, setTextoPieFirma] = useState('');

    const [historial, setHistorial] = useState([]);
    const [plantillas, setPlantillas] = useState([]);

    const [errorlist, setErrorlist] = useState({});

    const [tituloResumen, setTituloResumen] = useState();
    const [contenidoResumenIndividual, setContenidoResumenIndividual] = useState();
    const [profesionalResumenIndividual, setProfesionalResumenIndividual] = useState();
    const [registroMedicoResumenIndividual, setRegistroMedicoResumenIndividual] = useState();
    const [codigoHabilitacionResumenIndividual, setCodigoHabilitacionResumenIndividual] = useState();
    const [firmaResumenIndividual, setFirmaResumenIndividual] = useState();

    const [consolidado, setConsolidado] = useState('');

    /** Registro del historial cargado en el formulario (evolución: ver en editor antes de PDF) */
    const [consentimientoSeleccionado, setConsentimientoSeleccionado] = useState(null);
    const [modoVisualizacionHistorico, setModoVisualizacionHistorico] = useState(false);

    // Estados para controlar modales con React (como en ModalContraremisiones.js)
    const [showModalResumen, setShowModalResumen] = useState(false);
    const [showModalConsolidado, setShowModalConsolidado] = useState(false);
    /** Config para jsPDF nativo (misma vía que evolución); la vista previa del modal sigue en HTML */
    const [pdfNativoConfigConsentimiento, setPdfNativoConfigConsentimiento] = useState(null);

    const canvasRef = useRef(null);
    const [editorConsentimiento, setEditorConsentimiento] = useState(null);

    let history = useHistory();
    let userdata = [];
    const logoImg = '/smile/dist/img/logo-2.png';
    const [deshabilitarBotonGuardar, setDeshabilitarBotonGuardar] = useState(false);

    useEffect(() => {

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }
        
        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id
            }
        }

        axios.get('/get-client', config)
            .then(response => {
                if (response.status===200) {
                    setClient(response.data);
                }
            })
            .catch(error => {
                console.log(error);
            });
        
        axios.get('/perfil', config)
            .then(response => {
                if (response.status===200) {
                    
                    setNombreProfesional(response.data.name+' '+response.data.lastname);
                    setRegistroMedico(response.data.registro_medico ?? '');
                    setCodigoHabilitacion(response.data.codigo_habilitacion ?? '');
                    setFirmaimg(response.data.firma_blob);
                    setTextoPieFirma(response.data.texto_pie_firma || '');
                }
            })
            .catch(error => {
                console.log(error);
            });
        
        axios.get('/plantillas-consentimientos', config)
            .then(response => {
                setPlantillas(response.data);
            })
            .catch(error => {
                console.log(error);
            });
        
    },[]);

    /**
     * Firma del paciente: misma estructura que la del profesional (banda gris + mayúsculas en datos).
     * Sin trazo: mismo encabezado y celda derecha con línea para firmar en físico.
     */
    const htmlFirmaPacienteBloque = (firmaSrc, pieTextoPlano) => {
        const pieHtml = pieTextoPlano
            ? `<div style="font-size: 10px; color: #6c757d; white-space: pre-line; text-transform: uppercase;">${pieTextoPlano}</div>`
            : '<div style="font-size: 10px; color: #adb5bd;">&nbsp;</div>';
        const celdaFirma = firmaSrc
            ? `<img src="${firmaSrc}" alt="" style="max-width: 170px; max-height: 80px; display: block;" />`
            : `<div style="min-width: 140px; min-height: 64px; border-bottom: 1px solid #adb5bd;"></div>`;
        return `
                        <div style="margin-bottom: 12px; page-break-inside: avoid;">
                            <div style="background-color: #f8f9fa; font-weight: bold; padding: 8px 10px; font-size: 13px; text-align: left; color: #212529; border: 1px solid #dee2e6; border-bottom: 1px solid #dee2e6;">
                                FIRMA DEL PACIENTE
                            </div>
                            <table style="width: 100%; border-collapse: collapse; border: 1px solid #dee2e6; border-top: none;">
                                <tbody>
                                    <tr>
                                        <td style="padding: 8px 12px 8px 10px; vertical-align: middle; width: 45%;">
                                            ${pieHtml}
                                        </td>
                                        <td style="padding: 8px 10px; vertical-align: middle;">
                                            ${celdaFirma}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>`;
    };

    const htmlFirmaProfesionalDesdeItem = (item) => {
        if (!item.profesional || !item.firma_final) return '';
        const pieFirmaHtml = item.texto_pie_firma_usuario
            ? `<div style="font-size: 10px; color: #6c757d; white-space: pre-line;">${item.texto_pie_firma_usuario}</div>`
            : `<div style="font-size: 10px; color: #6c757d;">
                    ${item.profesional}<br/>
                    <strong>RM:</strong> ${item.registro_medico || 'N/A'} | <strong>Habilitación:</strong> ${item.codigo_habilitacion || 'N/A'}
                  </div>`;
        return `
                        <div style="margin-top: 10px; page-break-inside: avoid;">
                            <div style="background-color: #f8f9fa; font-weight: bold; padding: 8px 10px; font-size: 13px; text-align: left; color: #212529; border: 1px solid #dee2e6; border-bottom: 1px solid #dee2e6;">
                                FIRMA DEL PROFESIONAL
                            </div>
                            <table style="width: 100%; border-collapse: collapse; border: 1px solid #dee2e6; border-top: none;">
                                <tbody>
                                    <tr>
                                        <td style="padding: 8px 12px 8px 10px; vertical-align: middle; width: 45%;">
                                            ${pieFirmaHtml}
                                        </td>
                                        <td style="padding: 8px 10px; vertical-align: middle;">
                                            <img src="${item.firma_final}" alt="" style="max-width: 170px; max-height: 80px; display: block;" />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>`;
    };

    const piePacienteDesdeProps = () => {
        if (!props.paciente) return '';
        const n = `${props.paciente.primerNombre || ''} ${props.paciente.segundoNombre || ''} ${props.paciente.primerApellido || ''} ${props.paciente.segundoApellido || ''}`.trim();
        const d = props.paciente.tipoDocumento && props.paciente.numeroDocumento
            ? `${props.paciente.tipoDocumento} - ${props.paciente.numeroDocumento}`
            : (props.paciente.numeroDocumento || '');
        return [n, d].filter(Boolean).join('\n');
    };

    const cargaritems = () => {
        
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const esProfesionalIndependiente = debeFiltrarPorProfesional(userdata);

        const config2 = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id,
                id: paciente_id
            }
        }

        // 🆕 PROFESIONAL INDEPENDIENTE - Agregar parámetro de validación si es necesario
        if (esProfesionalIndependiente) {
            config2.params.validar_asignacion = true;
        }

        console.log('DEBUG Frontend - Enviando request con params:', JSON.stringify(config2.params)); // ✅ DEBUG mejorado

        axios.get('/consentimientos', config2)
            .then(response => {
                console.log('Consentimientos Cargados:', response.data);
                setHistorial(response.data);

                let consolidadoItems = "";

                response.data.map((item) => {

                    // 🎨 FORMATO TABLA CON BANDAS GRISES

                    // 1. Tabla de información básica (Fecha)
                    let segmentoCabecera = `
                        <div style="margin-bottom: 12px;">
                            <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                                <tbody>
                                    <tr>
                                        <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 30%; border: 1px solid #dee2e6;">FECHA Y HORA</td>
                                        <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${item.fecha}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>`;

                    // 2. Tabla de contenido del consentimiento
                    let segmentoContenido = '';
                    if (item.contenido) {
                        segmentoContenido = `
                            <div style="margin-bottom: 12px;">
                                <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                                    <tbody>
                                        <tr>
                                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">CONSENTIMIENTO INFORMADO</td>
                                        </tr>
                                        <tr>
                                            <td style="background-color: #ffffff; padding: 12px; border: 1px solid #dee2e6;">
                                                <style type="text/css">
                                                    .consentimiento-preview-rich,
                                                    .consentimiento-preview-rich * {
                                                        white-space: normal;
                                                        overflow-wrap: anywhere;
                                                        word-break: break-word;
                                                    }
                                                </style>
                                                <div class="consentimiento-preview-rich">${item.contenido}</div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>`;
                    }

                    // 3. Firma del paciente (misma banda gris con o sin trazo)
                    const segmentoFirmaPaciente = htmlFirmaPacienteBloque(item.firma_paciente || '', piePacienteDesdeProps());

                    // 4. Solo firma del profesional (RM/habilitación van en el pie de firma o imagen)
                    const segmentoProfesional = `
                        <div style="margin-bottom: 12px;">
                            ${htmlFirmaProfesionalDesdeItem(item)}
                        </div>`;

                    // 5. Separador entre consentimientos
                    let separadorConsentimientos = `<hr style="border-top: 2px solid #e0e0e0; margin: 25px 0;">`;

                    const itemParcial = segmentoCabecera + segmentoContenido + segmentoFirmaPaciente + segmentoProfesional + separadorConsentimientos;

                    consolidadoItems += itemParcial;
                    return null;
                });

                setConsolidado(consolidadoItems);
            })
            .catch(error => {
                console.log(error);
            })
    }



    const contenidoHandler = (event, editor) => {
        if (modoVisualizacionHistorico) return;
        setContenido(editor.getData());
    };

    const formatearFechaHoraParaInput = (fecha = new Date()) => {
        const d = fecha instanceof Date ? fecha : new Date(fecha);
        if (Number.isNaN(d.getTime())) return '';
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const h = String(d.getHours()).padStart(2, '0');
        const min = String(d.getMinutes()).padStart(2, '0');
        return `${y}-${m}-${day}T${h}:${min}`;
    };

    const formatearFechaHoraParaMostrar = (valor) => {
        if (!valor) return '';
        if (typeof valor === 'string' && valor.includes('T')) {
            const [fecha, hora] = valor.split('T');
            return `${fecha} ${hora}`;
        }
        const d = valor instanceof Date ? valor : new Date(valor);
        if (Number.isNaN(d.getTime())) return String(valor);
        return d.toLocaleString('es-CO', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });
    };

    const establecerFechaHoraActual = () => {
        setFechaHora(formatearFechaHoraParaInput(new Date()));
    };

    const handleSubmit = (e) => {
        
        e.preventDefault();

        if (modoVisualizacionHistorico) {
            return;
        }

        if (deshabilitarBotonGuardar || loading) {
            return;
        }

        if (!fechaHora || !String(fechaHora).trim()) {
            alert('La fecha y hora son obligatorias.');
            return;
        }

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        setDeshabilitarBotonGuardar(true);
        setLoading(true);

        const esProfesionalIndependiente = debeFiltrarPorProfesional(userdata);

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        const data = {
            paciente_id: pacienteId,
            profesional: nombreProfesional,
            registro_medico: registroMedico,
            codigo_habilitacion: codigoHabilitacion,
            contenido: contenido,
            hora_inicial: fechaHora,
            firma_paciente: ''
        };

        // 🆕 PROFESIONAL INDEPENDIENTE - Agregar parámetro de validación si es necesario
        if (esProfesionalIndependiente) {
            data.validar_asignacion = true;
        }

        if (canvasRef.current && !canvasRef.current.isEmpty()) {
            data.firma_paciente = canvasRef.current.toDataURL('image/png');
        }
        
        axios.post('/consentimiento', data, config)
            .then(response => {
                setLoading(false);
                setDeshabilitarBotonGuardar(false); // ✅ CORREGIDO: Rehabilitar botón después de guardar
                props.guardarCambios('El Consentimiento Informado Ha Sido Guardado con Exito en la Historia del Paciente');
                
                // ✅ CORREGIDO: Limpiar formulario después de guardar exitosamente
                setConsentimientoSeleccionado(null);
                setModoVisualizacionHistorico(false);
                setContenido('');
                if (canvasRef.current) {
                    canvasRef.current.clear();
                }
                const sel = document.getElementById('plantillas');
                if (sel) sel.value = '';
                
                // ✅ CORREGIDO: Recargar historial inmediatamente
                cargaritems();
            })
            .catch(error => {
                setLoading(false);
                setDeshabilitarBotonGuardar(false);
                console.log('Error Guardando el Consentimiento, Intenta Nuevamente:', error);
                const data = error.response && error.response.data;
                if (data && data.detail) {
                    console.error('Detalle servidor (consentimiento):', data.detail);
                }
                if (data && data.message) {
                    console.error('Mensaje servidor:', data.message);
                }
                if (data && data.errors) {
                    setErrorlist(data.errors);
                } else {
                    setErrorlist({});
                }
            })
            
    }


    /** HTML único para modal/PDF (misma fuente que los datos mostrados en el formulario cuando aplica) */
    const construirHtmlResumenConsentimiento = (resumenIndividual) => {
        const nombreCompleto = props.paciente ?
            `${props.paciente.primerNombre || ''} ${props.paciente.segundoNombre || ''} ${props.paciente.primerApellido || ''} ${props.paciente.segundoApellido || ''}`.trim() :
            'Paciente No Identificado';

        const documentoCompleto = props.paciente ?
            `${props.paciente.tipoDocumento || ''} - ${props.paciente.numeroDocumento || ''}` :
            'Documento No Disponible';

        let banner = `
            <div style="margin-bottom: 12px;">
                <div style="background-color: #e9ecef; padding: 8px 12px; font-weight: bold; font-size: 14px; border-radius: 4px; text-align: center; border: 1px solid #dee2e6;">
                    CONSENTIMIENTO INFORMADO
                </div>
            </div>`;

        let tablaInfoPaciente = `
            <div style="margin-bottom: 12px;">
                <table style="width: 100%; border-collapse: collapse; font-size: 13px; border: 1px solid #dee2e6;">
                    <tbody>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; width: 25%; border: 1px solid #dee2e6;">FECHA Y HORA</td>
                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${resumenIndividual.fecha}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">PACIENTE</td>
                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${nombreCompleto}</td>
                        </tr>
                        <tr>
                            <td style="background-color: #f8f9fa; font-weight: bold; padding: 8px 12px; border: 1px solid #dee2e6;">DOCUMENTO</td>
                            <td style="background-color: #ffffff; padding: 8px 12px; border: 1px solid #dee2e6;">${documentoCompleto}</td>
                        </tr>
                    </tbody>
                </table>
            </div>`;

        const cuerpoVistaConsent = (resumenIndividual.contenido && String(resumenIndividual.contenido).trim())
            ? resumenIndividual.contenido
            : '<p style="margin:0; color:#6c757d; font-style:italic;">Sin contenido especificado</p>';

        let tablaContenido = `
            <div style="margin-bottom: 12px; page-break-inside: avoid;">
                <div style="border: 1px solid #dee2e6; border-radius: 2px; padding: 12px 14px; background: #ffffff; font-size: 13px;">
                    <style type="text/css">
                        .consentimiento-preview-rich,
                        .consentimiento-preview-rich * {
                            white-space: normal;
                            overflow-wrap: anywhere;
                            word-break: break-word;
                        }
                    </style>
                    <div class="consentimiento-preview-rich">${cuerpoVistaConsent}</div>
                </div>
            </div>`;

        const piePacienteResumen = [nombreCompleto, documentoCompleto].filter(Boolean).join('\n');
        const tablaFirmaPaciente = htmlFirmaPacienteBloque(resumenIndividual.firma_paciente || '', piePacienteResumen);

        const itemProfResumen = {
            ...resumenIndividual,
            firma_final: resumenIndividual.firma_final || resumenIndividual.firma
        };
        const tablaProfesional = `
            <div style="margin-top: 16px; page-break-inside: avoid;">
            ${htmlFirmaProfesionalDesdeItem(itemProfResumen)}
            </div>`;

        return banner + tablaInfoPaciente + tablaContenido + tablaFirmaPaciente + tablaProfesional;
    };

    const obtenerDatosPacientePdf = () => {
        const p = props.paciente;
        if (!p) {
            return {
                nombreCompleto: 'Paciente no identificado',
                documentoCompleto: '—'
            };
        }
        const nombreCompleto = `${p.primerNombre || ''} ${p.segundoNombre || ''} ${p.primerApellido || ''} ${p.segundoApellido || ''}`.trim() || 'Paciente no identificado';
        const documentoCompleto = p.tipoDocumento && p.numeroDocumento
            ? `${p.tipoDocumento} - ${p.numeroDocumento}`
            : (p.numeroDocumento || '—');
        return { nombreCompleto, documentoCompleto };
    };

    /**
     * PDF con texto nativo (jsPDF + autotable), alineado con ModalEvolucion / generarPdfConTextoNativo.
     * Evita cortes raros del html2canvas. El bloque PACIENTE/DOCUMENTO lo inserta el helper.
     */
    const construirConfigPdfConsentimientoNativo = (payload) => {
        const { nombreCompleto, documentoCompleto } = obtenerDatosPacientePdf();
        const slug = props.docPaciente || props.paciente?.numeroDocumento || 'paciente';

        const config = {
            filename: `consentimiento-informado-${slug}.pdf`,
            paciente: {
                nombreCompleto,
                documentoCompleto
            },
            encabezadoPersonalizado: null,
            secciones: []
        };

        config.secciones.push({
            tipo: 'banner',
            titulo: 'CONSENTIMIENTO INFORMADO',
            contenido: 'CONSENTIMIENTO INFORMADO'
        });

        config.secciones.push({
            tipo: 'tabla-datos',
            datos: {
                filas: [
                    { etiqueta: 'FECHA Y HORA', valor: String(payload.fecha || '') }
                ]
            }
        });

        const cuerpoConsentPdf = (payload.contenido && String(payload.contenido).trim())
            ? payload.contenido
            : '<p style="margin:0; color:#6c757d; font-style:italic;">Sin contenido especificado</p>';

        config.secciones.push({
            tipo: 'texto',
            contenido: cuerpoConsentPdf
        });

        const firmasGrupo = [];
        const firmaProfesionalSrc = payload.firma_final || payload.firma;
        if (firmaProfesionalSrc) {
            const metaProf = payload.texto_pie_firma_usuario
                ? { tipo: 'profesional', textoPieFirma: payload.texto_pie_firma_usuario }
                : {
                    tipo: 'profesional',
                    nombre: payload.profesional || '',
                    registroMedico: payload.registro_medico || 'N/A',
                    codigoHabilitacion: payload.codigo_habilitacion || 'N/A'
                  };
            firmasGrupo.push({
                imagenBase64: firmaProfesionalSrc,
                metadata: metaProf
            });
            firmasGrupo.push({
                imagenBase64: payload.firma_paciente || '',
                metadata: {
                    tipo: 'paciente',
                    nombrePaciente: nombreCompleto,
                    documentoPaciente: documentoCompleto
                }
            });
        } else if (payload.firma_paciente) {
            firmasGrupo.push({
                imagenBase64: payload.firma_paciente,
                metadata: {
                    tipo: 'paciente',
                    nombrePaciente: nombreCompleto,
                    documentoPaciente: documentoCompleto
                }
            });
        }
        if (firmasGrupo.length > 0) {
            config.secciones.push({
                tipo: 'firmas-grupo',
                firmas: firmasGrupo
            });
        }

        return config;
    };

    const cargarConsentimientoHistorico = (item) => {
        setConsentimientoSeleccionado(item);
        setModoVisualizacionHistorico(true);
        setContenido(item.contenido || '');
        setErrorlist({});

        setTimeout(() => {
            if (!canvasRef.current) return;
            canvasRef.current.clear();
            if (item.firma_paciente) {
                try {
                    canvasRef.current.fromDataURL(item.firma_paciente);
                } catch (err) {
                    console.warn('No se pudo cargar firma del paciente en canvas:', err);
                }
            }
        }, 150);
    };

    const nuevoConsentimiento = () => {
        setConsentimientoSeleccionado(null);
        setModoVisualizacionHistorico(false);
        setContenido('');
        setErrorlist({});
        if (canvasRef.current) {
            canvasRef.current.clear();
        }
        const sel = document.getElementById('plantillas');
        if (sel) sel.value = '';
    };

    /** Vista previa / PDF desde el estado actual del formulario (incluye borrador nuevo o registro histórico cargado) */
    const abrirVistaImpresionDesdeFormulario = () => {
        let fechaTexto;
        let payload;

        if (modoVisualizacionHistorico && consentimientoSeleccionado) {
            fechaTexto = consentimientoSeleccionado.fecha;
            payload = {
                fecha: fechaTexto,
                contenido: contenido,
                firma_paciente: consentimientoSeleccionado.firma_paciente || (canvasRef.current && !canvasRef.current.isEmpty() ? canvasRef.current.toDataURL('image/png') : ''),
                profesional: consentimientoSeleccionado.profesional,
                registro_medico: consentimientoSeleccionado.registro_medico,
                codigo_habilitacion: consentimientoSeleccionado.codigo_habilitacion,
                firma: consentimientoSeleccionado.firma,
                firma_final: consentimientoSeleccionado.firma_final || consentimientoSeleccionado.firma,
                texto_pie_firma_usuario: consentimientoSeleccionado.texto_pie_firma_usuario
            };
        } else {
            fechaTexto = formatearFechaHoraParaMostrar(fechaHora || new Date());
            let firmaPac = '';
            if (canvasRef.current && !canvasRef.current.isEmpty()) {
                firmaPac = canvasRef.current.toDataURL('image/png');
            }
            payload = {
                fecha: fechaTexto,
                contenido: contenido,
                firma_paciente: firmaPac,
                profesional: nombreProfesional,
                registro_medico: registroMedico,
                codigo_habilitacion: codigoHabilitacion,
                firma: firmaimg,
                firma_final: firmaimg,
                texto_pie_firma_usuario: textoPieFirma || ''
            };
        }

        setTituloResumen('Consentimiento Informado');
        setContenidoResumenIndividual(construirHtmlResumenConsentimiento(payload));
        setPdfNativoConfigConsentimiento(construirConfigPdfConsentimientoNativo(payload));
        setShowModalResumen(true);
    };

    
    useEffect(() => {
        cargaritems();
    },[props.cargarHistorial]);

    useEffect(() => {
        if (!editorConsentimiento) return;
        try {
            if (typeof editorConsentimiento.enableReadOnlyMode === 'function') {
                if (modoVisualizacionHistorico) {
                    editorConsentimiento.enableReadOnlyMode('modal-consentimiento-hist');
                } else {
                    editorConsentimiento.disableReadOnlyMode('modal-consentimiento-hist');
                }
            } else {
                editorConsentimiento.isReadOnly = modoVisualizacionHistorico;
            }
        } catch (e) {
            console.warn('CKEditor readOnly:', e);
        }
    }, [modoVisualizacionHistorico, editorConsentimiento]);

    // ✅ AGREGADO: Cleanup cuando se cierran los modales (como en ModalContraremisiones.js)
    useEffect(() => {
        return () => {
            setShowModalResumen(false);
            setShowModalConsolidado(false);
        };
    }, []);


    const descargarPdf = () => {
        
        var opt = {
            margin:       12,
            filename:     `consentimientos.pdf`,
            image:        { type: 'jpeg', quality: 0.97 },
            html2canvas:  { scale: 2, useCORS: true, allowTaint: true },
            jsPDF:        { unit: 'mm', format: 'letter', orientation: 'portrait' }
        };

        let anamnesis = props.anamnesis();
        let consentimientosCompleto = "<img src='"+logoImg+"' class='app-logo-pdf' /><h1 class='ttl-pdf'>CONSENTIMIENTOS INFORMADOS</h1>"+anamnesis+"<div class='salto-pagina-pdf'></div>" + consolidado;

        html2pdf(consentimientosCompleto,opt);
    }


    const handleContenido = (contenidoPlantilla) => {

        let nombreCompletoPaciente = props.paciente.primerNombre + ' ' + (props.paciente.segundoNombre ? props.paciente.segundoNombre + ' ' : '') + props.paciente.primerApellido + ' ' + (props.paciente.segundoApellido ? props.paciente.segundoApellido : '');
        const refFecha = fechaHora ? new Date(fechaHora) : new Date();

        contenidoPlantilla = contenidoPlantilla.replace("{{nombre}}",nombreCompletoPaciente);
        contenidoPlantilla = contenidoPlantilla.replace("{{numero_documento}}",props.paciente.numeroDocumento);
        contenidoPlantilla = contenidoPlantilla.replace("{{tipo_documento}}",props.paciente.tipoDocumento);
        contenidoPlantilla = contenidoPlantilla.replace("{{fecha}}", refFecha.getDate() + '/' + (refFecha.getMonth() + 1) + '/' + refFecha.getFullYear());

        setContenido(contenidoPlantilla);
    }


    if (loggedIn) {
        return (
            
                <>
                    <style>{`
                        /* Espaciado alineado con vista previa / PDF (párrafos y títulos del editor) */
                        .consentimientos-editor .ck-editor__editable p {
                            margin: 0 0 0.9em 0 !important;
                        }
                        .consentimientos-editor .ck-editor__editable p:last-child {
                            margin-bottom: 0 !important;
                        }
                        .consentimientos-editor .ck-editor__editable h1,
                        .consentimientos-editor .ck-editor__editable h2,
                        .consentimientos-editor .ck-editor__editable h3,
                        .consentimientos-editor .ck-editor__editable h4 {
                            margin: 1em 0 0.5em 0 !important;
                        }
                        .consentimientos-editor .ck-editor__editable > *:first-child {
                            margin-top: 0 !important;
                        }
                    `}</style>
                    <section className="content">
                        <div className="container-fluid">

                            <div className="row">
                                <div className="col-md-9">

                                    <form id="role-form" onSubmit={handleSubmit} autoComplete="off">

                                        <div className="d-flex flex-wrap align-items-center justify-content-between mb-3 pb-2 border-bottom">
                                            <div className="d-flex flex-wrap align-items-center mb-1 mb-md-0">
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-outline-secondary mr-2 mb-1"
                                                    onClick={abrirVistaImpresionDesdeFormulario}
                                                    title="Abrir vista previa e imprimir o descargar PDF"
                                                >
                                                    <i className="fas fa-file-pdf mr-1"></i> Vista previa / PDF
                                                </button>
                                                {modoVisualizacionHistorico && (
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-secondary mb-1"
                                                        onClick={nuevoConsentimiento}
                                                        title="Limpiar formulario para un consentimiento nuevo"
                                                    >
                                                        <i className="fas fa-plus mr-1"></i> Nuevo consentimiento
                                                    </button>
                                                )}
                                            </div>
                                        </div>

                                        {modoVisualizacionHistorico && consentimientoSeleccionado && (
                                            <div className="alert alert-secondary py-2 mb-3" role="status">
                                                <i className="fas fa-history mr-2"></i>
                                                Viendo consentimiento del <strong>{consentimientoSeleccionado.fecha}</strong>. Los botones de vista PDF e imprimir están en la ventana de vista previa.
                                            </div>
                                        )}

                                        <div id="historiageneral">
                                            <div className="row">
                                                {!modoVisualizacionHistorico && (
                                                    <div className="col-md-12">
                                                        <div className="card" style={{ marginBottom: '15px' }}>
                                                            <div className="card-header" style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid rgba(0,0,0,0.06)' }}>
                                                                <h4 className="card-title mb-0" style={{ fontSize: '1rem', fontWeight: 700, color: '#323a45' }}>
                                                                    Fecha y Hora *
                                                                </h4>
                                                            </div>
                                                            <div className="card-body" style={{ padding: '20px' }}>
                                                                <div className="form-group mb-0">
                                                                    <label>Fecha y Hora *</label>
                                                                    <div className="input-group">
                                                                        <input
                                                                            type="datetime-local"
                                                                            className="form-control"
                                                                            required
                                                                            value={fechaHora || ''}
                                                                            onChange={(e) => setFechaHora(e.target.value)}
                                                                        />
                                                                        <div className="input-group-append">
                                                                            <button type="button" className="btn btn-sm btn-outline-secondary" onClick={establecerFechaHoraActual}>
                                                                                <i className="fas fa-clock"></i> Fecha y Hora Actual
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                <div className="col-md-12">
                                                    <label style={{fontSize:'0.85rem',marginBottom:'8px'}}>Seleccione La Plantilla o Digite Su Contenido</label>
                                                    

                                                    <div className="form-group">
                                                        <select name="plantillas" className="form-control" id="plantillas" disabled={modoVisualizacionHistorico} onChange={(e) => handleContenido(e.target.value)} >
                                                            <option value="">Seleccionar Plantilla...</option>
                                                            {
                                                                plantillas.map((plantilla) => 
                                                                    <option key={plantilla.id} value={plantilla.contenido}>{plantilla.titulo}</option>
                                                                )
                                                            }
                                                        </select>
                                                    </div>
                                                    <div className="form-group">
                                                        <CKEditor
                                                            editor={ClassicEditor}
                                                            onReady={(editor) => setEditorConsentimiento(editor)}
                                                            onChange={contenidoHandler}
                                                            data={contenido}
                                                        />
                                                    </div>
                                                    <div className="invalid-feedback visible">
                                                    {errorlist.contenido}
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <label>Firma del paciente <span className="text-muted font-weight-normal">(opcional)</span></label>
                                                    <small className="d-block text-muted mb-1">Puede guardar sin firma y entregar el documento impreso para que el paciente firme después.</small>
                                                    <div className="form-group" style={modoVisualizacionHistorico ? { pointerEvents: 'none', opacity: 0.95 } : undefined}>
                                                        <SignatureCanvas ref={canvasRef} penColor='#242424' canvasProps={{width: 300, height: 130, className: 'sigCanvas', style:{border:'1px solid #c4c4c4'}}} />
                                                        <br />
                                                        <button type="button" className="btn btn-primary btn-sm" disabled={modoVisualizacionHistorico} onClick={(e) => { e.preventDefault(); if (canvasRef.current) canvasRef.current.clear(); }}><i className="fas fa-eraser"></i> Borrar</button>&nbsp;
                                                    </div>
                                                    <div className="invalid-feedback visible">
                                                    {errorlist.firma_paciente}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="card">
                                            <div id="profesional-atiende">
                                                <div className="card-body" style={{padding: '0.7rem'}}>
                                                    <div className="row">
                                                        {(modoVisualizacionHistorico && consentimientoSeleccionado
                                                            ? (consentimientoSeleccionado.firma_final || consentimientoSeleccionado.firma)
                                                            : firmaimg) && (
                                                            <div className="col-md-4">
                                                                <div className="form-group" style={{marginBottom: '0.4rem'}}>
                                                                    <label>Firma del profesional</label>
                                                                    <br></br>
                                                                    <img
                                                                        src={modoVisualizacionHistorico && consentimientoSeleccionado
                                                                            ? (consentimientoSeleccionado.firma_final || consentimientoSeleccionado.firma)
                                                                            : firmaimg}
                                                                        className="firma-profesional-hc"
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            </div>
                                                        )}
                                                        <div className={(modoVisualizacionHistorico && consentimientoSeleccionado
                                                            ? (consentimientoSeleccionado.firma_final || consentimientoSeleccionado.firma)
                                                            : firmaimg) ? 'col-md-8' : 'col-md-12'}>
                                                            <div className="form-group" style={{marginBottom: '0.4rem'}}>
                                                                <label>Pie de firma</label>
                                                                <br></br>
                                                                {(modoVisualizacionHistorico && consentimientoSeleccionado && consentimientoSeleccionado.texto_pie_firma_usuario) ? (
                                                                    <div style={{ whiteSpace: 'pre-line', fontSize: '0.75rem', color: '#495057', lineHeight: '1.6' }}>
                                                                        {consentimientoSeleccionado.texto_pie_firma_usuario}
                                                                    </div>
                                                                ) : textoPieFirma ? (
                                                                    <div style={{ whiteSpace: 'pre-line', fontSize: '0.75rem', color: '#495057', lineHeight: '1.6' }}>
                                                                        {textoPieFirma}
                                                                    </div>
                                                                ) : (
                                                                    <div style={{ fontSize: '0.75rem', color: '#6c757d' }}>
                                                                        {modoVisualizacionHistorico && consentimientoSeleccionado ? consentimientoSeleccionado.profesional : nombreProfesional}
                                                                        <br />
                                                                        <small>
                                                                            RM: {(modoVisualizacionHistorico && consentimientoSeleccionado ? consentimientoSeleccionado.registro_medico : registroMedico) || 'N/A'}
                                                                            {' '}| Hab: {(modoVisualizacionHistorico && consentimientoSeleccionado ? consentimientoSeleccionado.codigo_habilitacion : codigoHabilitacion) || 'N/A'}
                                                                        </small>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                            
                                        <div className="row">
                                            <div className="col-md-12 d-flex flex-wrap align-items-center">
                                                <button type="submit" className="btn btn-secondary mb-2 mb-sm-0 mr-2" disabled={deshabilitarBotonGuardar || modoVisualizacionHistorico}>
                                                    Guardar&nbsp;
                                                    {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                                                </button>
                                                <a href="#" className="btn btn-outline-secondary mb-2 mb-sm-0" onClick={(e) => { e.preventDefault(); props.cerrarModal(); }}>Cerrar</a>
                                            </div>
                                        </div>

                                        
                                    
                                    </form>
                                
        
                                </div>
                                <div className="col-md-3">
                                    
                                    
                                    
                                    <div className="timeline-evolucion">

                                        <b className="titulo-historial">Historial</b>

                                        {

                                            historial.map((item) => 
                                                
                                                    <div
                                                        key={item.id}
                                                        className="timeline-item-container"
                                                        onClick={() => cargarConsentimientoHistorico(item)}
                                                        style={{
                                                            cursor: 'pointer',
                                                            ...(consentimientoSeleccionado && consentimientoSeleccionado.id === item.id
                                                                ? { backgroundColor: 'rgba(23, 162, 184, 0.12)', borderRadius: '8px', padding: '4px 6px' }
                                                                : {})
                                                        }}
                                                    >
                                                        <div className="timeline-punto-container"><div className="timeline-punto" style={consentimientoSeleccionado && consentimientoSeleccionado.id === item.id ? { backgroundColor: '#17a2b8', borderColor: '#17a2b8' } : undefined}></div></div>
                                                        <div className="timeline-meta">{formatFecha(new Date(item.fecha))}</div>
                                                    </div>
                                                )
                                        }

                                    </div>

                                    {/*
                                      Resumen consolidado (todos los consentimientos): oculto a propósito.
                                      La impresión/PDF de ese HTML suele salir como imagen (html2canvas) con errores.
                                      El historial ya permite abrir cada registro con vista previa/PDF por documento.
                                    <button className="btn btn-primary btn-resumen-historico" onClick={() => setShowModalConsolidado(true)}>Resumen</button>
                                    <br />
                                    <button className="btn btn-primary btn-resumen-historico" onClick={descargarPdf}>Descargar</button>
                                    */}

                                </div>
                            
                            </div>
                            
                        </div>
                    </section>

                {/* ✅ MODALES CON REACT STATE (como en ModalRemisiones.js) */}
                {showModalResumen && (
                    <ModalResumenRemision 
                        idModal="modalResumenConsentimientos"
                        titulo={tituloResumen} 
                        contenido={contenidoResumenIndividual} 
                        profesional={profesionalResumenIndividual} 
                        registro={registroMedicoResumenIndividual} 
                        codigo={codigoHabilitacionResumenIndividual} 
                        firma={firmaResumenIndividual}
                        paciente={props.paciente}
                        tipoArchivo={'consentimiento-informado'}
                        cliente={client}
                        docPaciente={props.docPaciente || props.paciente?.numeroDocumento}
                        incluirTituloPdf={false}
                        pdfAltoContraste={true}
                        pdfNativoConfig={pdfNativoConfigConsentimiento}
                        onClose={() => {
                            setShowModalResumen(false);
                            setPdfNativoConfigConsentimiento(null);
                        }}
                    />
                )}

                {/*
                  Modal consolidado deshabilitado junto al botón Resumen (ver comentario arriba).
                {showModalConsolidado && (
                    <ModalResumenRemision 
                        idModal="modalConsolidadoConsentimientos"
                        titulo="Resumen consentimientos informados" 
                        contenido={consolidado}
                        paciente={props.paciente}
                        tipoArchivo={'historico-consentimientos-informados'}
                        cliente={client}
                        pdfAltoContraste={true}
                        onClose={() => setShowModalConsolidado(false)}
                    />
                )}
                */}

                </>
                
            
        );
    }

    return (
        <Loading />
    );
}
export default ModalConsentimientos;